import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-nc-eu': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.7 8C103.6 8 0 124.8 0 256 0 392.3 111.7 504 247.7 504 377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zM248.3 458.7C136.3 458.7 44.7 366.2 44.7 256 44.7 232.8 48.4 210.8 55.6 190L121.3 219.1H116.6V248.6H139.9C139.9 254.8 139.5 251.8 139.5 268.1H116.7V297.6H143.7C155.1 364.6 210.9 398.9 268.3 398.9 294.9 398.9 318.9 391 333.1 383.1L323.1 337C314.4 341.6 294.9 347.8 275.8 347.8 247.6 347.8 217.7 336.9 208.5 297.6H298.8L427.1 354.4C425.6 356.5 370.9 458.7 248.3 458.7zM231.6 268.1L231.1 267.7 232 268.1H231.6zM308.8 248.6H312.5V219.1H242.2L213.6 206.5C216.1 201 219 196 222.4 192.2 235.3 176.4 253.5 169.8 273.5 169.8 291.8 169.8 308.8 175.2 319.6 179.8L331.2 132.5C316.2 125.9 294.2 120.1 268.9 120.1 229.9 120.1 196.7 135.9 173 162.4 167.7 168.5 163.2 175.3 159.1 182.5L77.5 146.4C142.1 49.6 235.2 52.8 248.2 52.8 361.2 52.8 451.2 143 451.2 256.2 451.2 274.9 449.1 292.5 444.9 309.1L308.8 248.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-nc-eu.js
// module id = IKHi
// module chunks = 144